module.exports = __webpack_public_path__ + "img/vinn.e62248e7.png";